<div role="dialog" aria-labelledby="dialogTitle">
  <div class="modal-header">
    <h4 id="dialogTitle" role="header" class="modal-title module-title">{{"plan.title"|translate}}</h4>
    <button type="button" value="Close" class="close" aria-label="Close" (click)="dismiss()">
      <span class="icon-Close" aria-hidden="true" pTooltip="{{'dialog.box.close.tooltip'|translate}}" tooltipPosition="right"></span>
    </button>
  </div>
  <div class="modal-body">
    <div class="col-12">
      <form #createPlanForm>
        <div class="row">
          <div class='col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-group'>
            <wfm-textbox #planName
                         (wfmTextboxEvent)="setPlanName($event.target.value)"
                         inputName="planName"
                         (inputOnInput)="checkFormValidationStatus()"
                         (inputOnBlur)="checkPlanNameExists($event)"
                         [maxLength]="32"
                         inputId="planName"
                         [required]="true"
                         [textValue]="planModel.planName"
                         label='{{ getLabelByFieldName("planName") | async }}' 
                         hasFocus=true>
            </wfm-textbox>
          </div>
        </div>
        <div class="row">
          <div class='col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-group'>
            <wfm-select #entityType
                        selectName="entityType"
                        selectId="entityType"
                        label="{{ getLabelByFieldName('entityType')|async}}"
                        [items]="entityTypeList"
                        placeHolder="{{ getLabelByFieldName('entityType')|async}}"
                        [disabled]="entityTypeDisabled"
                        (wfmSelectEvent)="updateEntityType($event)"
                        [selectedItem]="planModel.entityType">

            </wfm-select>
          </div>
        </div>


        <div class="row">
          <div class='col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-group'>
            <wfm-select #entity
                        selectName="entity"
                        selectId="entity"
                        label="{{getEntityLabel()|async}}"
                        [items]="entityList"
                        placeHolder="{{getEntityLabel()|async}}"
                        [showLoading]="entityListLoading"
                        [disabled]="entityDisabled"
                        (wfmSelectEvent)="updateEntity($event)"
                        [selectedItem]="selectedEntity">

            </wfm-select>
          </div>
        </div>

        <div class="row">
          <div class='col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-group'>
            <wfm-select #forecast
                        selectName="forecast"
                        selectId="forecast"
                        label="{{ getLabelByFieldName('forecastLabel')|async}}"
                        [items]="forecastList"
                        placeHolder="{{ getLabelByFieldName('forecastLabel')|async}}"
                        [showLoading]="forecastListLoading"
                        [disabled]="forecastDisabled"
                        (wfmSelectEvent)="updateForecast($event)"
                        [selectedItem]="selectedForecast">

            </wfm-select>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="modal-footer">
    <div class="modal-buttons">
      <breeze-button buttonText="{{'plan.cancel.btn'|translate}}"
                     id="cancel-btn"
                     [isSecondary]="true"
                     (clicked)="dismiss()"></breeze-button>

      <breeze-button buttonText="{{'plan.create.btn'|translate}}"
                     id="create-plan-btn"
                     [isPrimary]="true"
                     [isDisabled]="!enableCreatePlan"
                     (clicked)="createPlan()"></breeze-button>
    </div>
  </div>
</div>
